import { useState, useEffect, useCallback } from "react";
import moment from "moment";
import profileImg from "../../assets/images/profile.png";
import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import Select from "react-select";
import Editor from "react-simple-wysiwyg";
import { useStateContext } from "../../contexts/ContextProvider";
import { leaveSessions } from "../../data";
import AuthService from "../../services/auth.service";
import LeaveHistoryService from "../../services/leaveHistory.service";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditLeave = ({ selectedData, setSuccess, fetchData, setHeading }) => {
  const user = AuthService.getCurrentUser();
  const { editLeaveModal, setEditLeaveModal, getNameInitials } = useStateContext();

  const [leaveCat, setLeaveCat] = useState([]);

  const [fromDate, setFromdate] = useState();
  const [toDate, setToDate] = useState();

  // console.log("selectedData", selectedData);

  const [loading, setLoading] = useState(false);

  const initialData = {
    rid: "",
    leaveCategory: "",
    leaveReason: "",
    fromDate: "",
    formatedFromDate: "",
    fromDateSession: "0",
    toDate: "",
    formatedToDate: "",
    toDateSession: "0",
    duration: "0",
    remark: ``,
    dor: "",
    formatedDOR: "",
  };

  const [details, setDetails] = useState(initialData);

  const [approvalHierarchy, setApprovalHierarchy] = useState([
    {
      type: "TL",
      empid: "",
      name: "",
    },
    {
      type: "HR",
      empid: "",
      name: "",
    },
  ]);

  const fetchApprovalHierarchy = useCallback(() => {
    const req1 = {
      userId: user.empid,
    };

    LeaveHistoryService.getTeamLeadDetail(req1)
      .then((response) => {
        if (response.data) {
          const data = [...approvalHierarchy];
          data[0].empid = response.data.empid;
          data[0].name = response.data.name;
          setApprovalHierarchy(data);
        }
      })
      .catch((e) => console.log(e));

    const req2 = {
      Empid: user.empid,
    };

    LeaveHistoryService.getHRDetail(req2)
      .then((response) => {
        if (response.data) {
          const data = [...approvalHierarchy];
          data[1].empid = response.data.empid;
          data[1].name = response.data.name;
          setApprovalHierarchy(data);
        }
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    if (editLeaveModal) {
      fetchApprovalHierarchy();
    }
  }, [editLeaveModal, fetchApprovalHierarchy]);

  const [html, setHtml] = useState(
    "Dear Sir/Madam,  </br> <br> <br> <br> Thanks & Regards, <br> " +
      user.userName
  );

  const [dor, setDOR] = useState("");

  // const currentDate = new Date();

  useEffect(() => {
    if (editLeaveModal) {
      setFromdate(
        new Date(
          `${moment(selectedData && selectedData.fromDate, "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          )}T00:00:00`
        )
      );
      setToDate(
        new Date(
          `${moment(selectedData && selectedData.toDate, "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          )}T00:00:00`
        )
      );
      setDOR(
        new Date(
          `${moment(selectedData && selectedData.dor, "DD/MM/YYYY").format(
            "YYYY-MM-DD"
          )}T00:00:00`
        )
      );
      setDetails((prevState) => ({
        ...prevState,
        rid: selectedData && selectedData.rid,
        leaveReason: selectedData && selectedData.leaveReason,
        fromDate: moment(
          selectedData && selectedData.fromDate,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD"),
        formatedFromDate: moment(
          selectedData && selectedData.fromDate,
          "DD/MM/YYYY"
        ).format("D MMMM, YYYY"),
        fromDateSession: selectedData.fDatehalfday,
        toDate: moment(
          selectedData && selectedData.toDate,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD"),
        formatedToDate: moment(
          selectedData && selectedData.toDate,
          "DD/MM/YYYY"
        ).format("D MMMM, YYYY"),
        toDateSession: selectedData.tDatehalfday,
        duration: selectedData.leavedays,
        remark: selectedData.description,
        dor: moment(selectedData && selectedData.dor, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        ),
        formatedDOR: moment(
          selectedData && selectedData.dor,
          "DD/MM/YYYY"
        ).format("D MMMM, YYYY"),
      }));
      setHtml(selectedData.description);
    }
  }, [selectedData, editLeaveModal]);

  const onChange = (e) => {
    setHtml(e.target.value);
    setDetails((prevState) => ({
      ...prevState,
      remark: e.target.value,
    }));
  };

  useEffect(() => {
    if (editLeaveModal) {
      fetchLeaveTypes();
    }
  }, [editLeaveModal]);

  const fetchLeaveTypes = () => {
    LeaveHistoryService.getLeaveCategory()
      .then((response) => {
        if (response.data) {
          const x = response.data.map((item) => ({
            label: item.catname,
            value: item.catid,
          }));
          setLeaveCat(x);
        }
      })
      .catch((e) => console.log(e));
  };

  const fetchWeekendHolidaysList = (fromdate, todate, sHsts, eHsts) => {
    const payload = {
      fromdate: fromdate,
      todate: todate,
      sHsts: sHsts,
      eHsts: eHsts,
    };
    LeaveHistoryService.getWeekendHolidaysList(payload)
      .then((resp) => {
        // console.log(resp.data);
        setDetails((prevState) => ({
          ...prevState,
          duration: resp.data[0].workday,
        }));
      })
      .catch((e) => console.log(e));
  };

  const handleFromDateChange = (e) => {
    setFromdate(e.value);
    const fDate = moment(new Date(e.value)).format("YYYY-MM-DD");
    setDetails((prevState) => ({
      ...prevState,
      fromDate: fDate,
      formatedFromDate: moment(new Date(e.value)).format("D MMM YYYY"),
    }));
    fetchWeekendHolidaysList(
      fDate,
      details.toDate,
      details.fromDateSession,
      details.toDateSession
    );
  };

  const handleToDateChange = (e) => {
    setToDate(e.value);
    const tdate = moment(new Date(e.value)).format("YYYY-MM-DD");
    setDetails((prevState) => ({
      ...prevState,
      toDate: tdate,
      formatedToDate: moment(new Date(e.value)).format("D MMM YYYY"),
    }));
    fetchWeekendHolidaysList(
      details.fromDate,
      tdate,
      details.fromDateSession,
      details.toDateSession
    );
  };

  const handleDORChange = (e) => {
    setDOR(e.value);
    const dor = moment(new Date(e.value)).format("YYYY-MM-DD");
    setDetails((prevState) => ({
      ...prevState,
      dor: dor,
      formatedDOR: moment(new Date(e.value)).format("D MMM YYYY"),
    }));
  };

  const handleSelectLeaveCat = (e) => {
    // console.log(e);
    setDetails({
      ...details,
      leaveReason: e.label,
    });
  };

  const hideLeaveModal = (e) => {
    e.preventDefault();
    setEditLeaveModal(false);
  };

  const handleSelect = (e, name) => {
    if (name === "fromDateSession") {
      setDetails((prevState) => ({
        ...prevState,
        fromDateSession: e.value,
      }));

      fetchWeekendHolidaysList(
        details.fromDate,
        details.toDate,
        e.value,
        details.toDateSession
      );
    } else if (name === "toDateSession") {
      fetchWeekendHolidaysList(
        details.fromDate,
        details.toDate,
        details.fromDateSession,
        e.value
      );

      setDetails((prevState) => ({
        ...prevState,
        toDateSession: e.value,
      }));
    }
  };

  const handleUpdateLeave = () => {
    // console.log(details);

    const payload = {
      rid: details.rid,
      // emp_id: user && user.empid,
      catagoryId: details.leaveCategory,
      fromDate: details.fromDate,
      toDate: details.toDate,
      leavedays: details.duration,
      leaveReason: details.leaveReason,
      dor: details.dor,
      description: details.remark,
      fDatehalfday: details.fromDateSession,
      tDatehalfday: details.toDateSession,
    };

    // console.log("payload", payload);

    setLoading(true);

    if (
      details.fromDate !== "" &&
      details.toDate !== "" &&
      details.toDate !== "" &&
      details.leaveReason !== ""
    ) {
      LeaveHistoryService.updateleaveRequest(payload)
        .then((resp) => {
          if (resp.data) {
            setSuccess(true);
            setHeading("Leave Updated Successfully!");
            setEditLeaveModal(false);
            fetchData();
            setDetails(initialData);
            setLoading(false);
          }
        })
        .catch((e) => console.log(e));
    } else {
      toast.warn("*Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  return (
    <>
      <div className="filter-flex">
        <div className="sort-list">
          <div className="leaveModalHeading">
            <div className="row">
              <div className="col-lg-6">
                <div className="left-flex">
                  <div className="heading">
                    <span>Edit Applied Leave </span>
                  </div>
                  <div className="profile">
                    {user && user.profile ? (
                      <img src={profileImg} width={40} alt="profileImg" />
                    ) : (
                      <>
                        {user.role === "1" ? (
                          <div className="circle">
                            <span>HR</span>
                          </div>
                        ) : (
                          <div className="circle">
                            <span>{getNameInitials(user && user.userName)}</span>
                          </div>
                        )}
                      </>
                    )}
                    <div className="profile-info">
                      <span className="name">{user && user.userName}</span>
                      <span className="desig">{user && user.designation}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="balance">
                  <div className="left">
                    <span>Balance</span>
                  </div>
                  <div className="right">
                    <div className="flex">
                      <span>Monthly:</span>
                      <span className="count">01</span>
                    </div>
                    <div className="flex">
                      <span>Quarterly:</span>
                      <span className="count">3.5</span>
                    </div>
                    <div className="flex">
                      <span>Yearly:</span>
                      <span className="count">10</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="leaveModalBody">
            <div className="row">
              <div className="col-lg-6">
                <div className="mb-3 calendar-relative">
                  <label htmlFor="leaveType" className="form-label">
                    From Date *
                  </label>
                  <Calendar
                    value={fromDate}
                    onChange={handleFromDateChange}
                    view="date"
                    dateFormat="dd, MM, yy"
                    style={{ width: "100%", height: "45px" }}
                    showIcon
                    // disabledDays={[0, 6]}
                    selectOtherMonths
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label htmlFor="leaveType" className="form-label">
                    Session
                  </label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,

                        height: "45px",
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        border: "1px solid rgba(210, 205, 218, 1)",
                      }),
                      option: (baseStyles, { isFocused, isSelected }) => ({
                        ...baseStyles,
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        borderRadius: "4px",
                        backgroundColor: isSelected
                          ? "rgba(177, 206, 251, 1)"
                          : isFocused
                          ? "rgba(177, 206, 251, 1)"
                          : "rgba(255, 255, 255, 1)",
                        color: isSelected
                          ? "rgba(78, 70, 94, 1)"
                          : isFocused
                          ? "rgba(78, 70, 94, 1)"
                          : "rgba(78, 70, 94, 1)",
                      }),
                      menu: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                      }),
                    }}
                    options={leaveSessions}
                    onChange={(e) => {
                      handleSelect(e, "fromDateSession");
                    }}
                    value={
                      Array.isArray(leaveSessions)
                        ? leaveSessions.filter(
                            (option) => option.value === details.fromDateSession
                          )
                        : []
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3 calendar-relative">
                  <label htmlFor="leaveType" className="form-label">
                    To Date *
                  </label>
                  <Calendar
                    value={toDate}
                    onChange={handleToDateChange}
                    view="date"
                    dateFormat="dd, MM, yy"
                    style={{ width: "100%", height: "45px" }}
                    showIcon
                    // disabledDays={[0, 6]}
                    selectOtherMonths
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label htmlFor="leaveType" className="form-label">
                    Session
                  </label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        height: "45px",
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        border: "1px solid rgba(210, 205, 218, 1)",
                      }),
                      option: (baseStyles, { isFocused, isSelected }) => ({
                        ...baseStyles,
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        borderRadius: "4px",
                        backgroundColor: isSelected
                          ? "rgba(177, 206, 251, 1)"
                          : isFocused
                          ? "rgba(177, 206, 251, 1)"
                          : "rgba(255, 255, 255, 1)",
                        color: isSelected
                          ? "rgba(78, 70, 94, 1)"
                          : isFocused
                          ? "rgba(78, 70, 94, 1)"
                          : "rgba(78, 70, 94, 1)",
                      }),
                      menu: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                      }),
                    }}
                    options={leaveSessions}
                    onChange={(e) => {
                      handleSelect(e, "toDateSession");
                    }}
                    value={
                      Array.isArray(leaveSessions)
                        ? leaveSessions.filter(
                            (option) => option.value === details.toDateSession
                          )
                        : []
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label htmlFor="leaveType" className="form-label">
                    Leave Reason *
                  </label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        height: "45px",
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        border: "1px solid rgba(210, 205, 218, 1)",
                      }),
                      option: (baseStyles, { isFocused, isSelected }) => ({
                        ...baseStyles,
                        fontSize: "16px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        borderRadius: "4px",
                        backgroundColor: isSelected
                          ? "rgba(177, 206, 251, 1)"
                          : isFocused
                          ? "rgba(177, 206, 251, 1)"
                          : "rgba(255, 255, 255, 1)",
                        color: isSelected
                          ? "rgba(78, 70, 94, 1)"
                          : isFocused
                          ? "rgba(78, 70, 94, 1)"
                          : "rgba(78, 70, 94, 1)",
                      }),
                      menu: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                      }),
                    }}
                    options={leaveCat}
                    onChange={handleSelectLeaveCat}
                    // value={details.leaveCategory}
                    value={
                      Array.isArray(leaveCat)
                        ? leaveCat.filter((option) =>
                            details.leaveReason === option.label
                          )
                        : []
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3 calendar-relative">
                  <label htmlFor="leaveType" className="form-label">
                    Date Of Return *
                  </label>
                  <Calendar
                    value={dor}
                    onChange={handleDORChange}
                    view="date"
                    dateFormat="dd, MM, yy"
                    style={{ width: "100%", height: "45px" }}
                    showIcon
                    // disabledDays={[0, 6]}
                    selectOtherMonths
                  />
                </div>
              </div>
            </div>
            <div className="right-flex">
              <span>Applying For: </span>
              <span className="dayscount">{details.duration} Days</span>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="mb-3">
                  <label htmlFor="leaveType" className="form-label mb-3">
                    Approval Hierarchy
                  </label>
                  <div className="approval-list">
                    <div className="item">
                      <div className="icon profile">
                        {approvalHierarchy[0].profile &&
                        approvalHierarchy[0].profile ? (
                          <img src={profileImg} width={40} alt="profileImg" />
                        ) : (
                          <>
                            <div className="circle">
                              <span>{getNameInitials(approvalHierarchy && approvalHierarchy[0].name)}</span>
                            </div>
                          </>
                        )}
                      </div>
                      <div className="info">
                        <span className="name">
                          {approvalHierarchy[0].name}
                        </span>
                        <span className="code">
                          #{approvalHierarchy[0].empid}
                        </span>
                        <span className="desig">RM</span>
                      </div>
                    </div>

                    {user.role !== "1" && (
                      <>
                        <div className="item">
                          <div className="icon profile">
                            {approvalHierarchy[1].profile &&
                            approvalHierarchy[1].profile ? (
                              <img
                                src={profileImg}
                                width={40}
                                alt="profileImg"
                              />
                            ) : (
                              <>
                                <div className="circle">
                                  <span>{getNameInitials(approvalHierarchy && approvalHierarchy[1].name)}</span>
                                </div>
                              </>
                            )}
                          </div>
                          <div className="info">
                            <span className="name">
                              {approvalHierarchy[1].name}
                            </span>
                            <span className="code">
                              #{approvalHierarchy[1].empid}
                            </span>
                            <span className="desig">HR</span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="mb-3">
                  <label htmlFor="leaveType" className="form-label mb-3">
                    Short Description
                  </label>
                  <Editor value={html} onChange={onChange} />
                </div>
              </div>
            </div>
            <div className="sort-action">
              <button className="btn btn-reset" onClick={hideLeaveModal}>
                Cancel
              </button>
              <button
                className="btn btn-apply"
                disabled={loading}
                onClick={handleUpdateLeave}
              >
                {loading ? "Submitting..." : "Update"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditLeave;
